const addPositiveSymbol = (value) => {
  return value > 0 ? '+' + value : value
}

export { addPositiveSymbol }
